module.exports = function(app) {
    app.directive('prescriptsForms', function() {

        return {
            restrict: 'A',
            replace: true,
           // template: require('directives/prescriptsForms.html'),
            templateUrl: 'prescriptions.appTemplate.html/chmhom/directives/prescriptsForms',

            // scope: {},

            controller: ['$scope',
                function($scope) {

                }
            ]
        };
    });
}